<template>
  <div class="wrapper">
    <!-- <div class="nav"> -->
      <!-- <img src="http://conventus.online/static/img/logo.jpg" style="padding-left: 15px;"/> -->
    <!-- </div> -->

    <div class="main">

      <h2 class="h2">Списки пользователей</h2>
      <EditTitle :defaultValue="currentGroup.name" />

      <div class="toolbar">
        <!-- <a-spin :spinning="allListsProgress" :indicator="indicator" wrapperClassName="spin"> -->
        <GroupsListSelect />
        <!-- </a-spin> -->

        <AddGroupButton/>
      </div>

      <UsersList/>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import UsersList from './UsersList';
import GroupsListSelect from './GroupsListSelect';
import EditTitle from './EditTitle';
import AddGroupButton from './AddGroupButton';

export default {
  components: {
    UsersList,
    AddGroupButton,
    GroupsListSelect,
    EditTitle,
    mapState
  },
  data () {
    return {
      indicator: <i class="anticon anticon-loading anticon-spin ant-spin-dot" style="font-size: 24px;"></i>
    }
  },
  async created () {
    await this.$store.dispatch('getAllGroups')
    await this.$store.commit("setCurrentGroup", this.allGroupsList[0]);
    await this.$store.dispatch('getAllMembers')
    // await this.$store.dispatch('getMemberQuizzes')
  },
  computed: {
    ...mapState([
      'allGroupsList',
      'currentGroup'
    ])
  },
}
</script>
<style scoped lang="scss">
.nav {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.wrapper {
  display: flex;
}
.main {
  flex-basis: 100%;
  padding: 70px 1% 10% 70px;

  @media (max-width: 500) {
    padding: 5px;
  }
}

.btn-wrapper-add-link {
  margin-right: 5px;
  margin-top: 5px;
  display: block;
  &--extended-margin {
    margin-right: 10px;
  }
}

.toolbar {
  margin-bottom: 20px;
}

.spin {
  display: inline-block;
}

.create-link-btn {
  display: inline-block;
}

.h2 {
  display: inline-block;
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.50);
}
</style>